module.exports = __webpack_public_path__ + "img/Download cloud Icon - charcoal.3c1da7ca.svg";